import { Toaster } from 'sonner';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import About from '@/components/About';
import WhatWeMove from '@/components/WhatWeMove';
import Capabilities from '@/components/Capabilities';
import Reach from '@/components/Reach';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

const APP_STYLE = { backgroundColor: '#050B14', color: '#F8FAFC' };

const TOAST_OPTIONS = {
  style: {
    fontFamily: 'Manrope, sans-serif',
    background: '#112240',
    border: '1px solid rgba(0,229,255,0.2)',
    color: '#F8FAFC',
  },
};

function App() {
  return (
    <div style={APP_STYLE} className="antialiased">
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhatWeMove />
        <Capabilities />
        <Reach />
        <Contact />
      </main>
      <Footer />
      <Toaster position="bottom-right" theme="dark" toastOptions={TOAST_OPTIONS} />
    </div>
  );
}

export default App;
